import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { Layers, Clock, Cpu } from 'lucide-react';

const topics = [
  {
    icon: Layers,
    title: 'Transformer Architecture',
    description: 'Multi-head attention, self-attention mechanisms, positional encoding',
    color: 'primary'
  },
  {
    icon: Clock,
    title: 'Training Pipeline Evolution',
    description: 'Pre-training → Instruction Tuning → RLHF → RLVR',
    color: 'secondary'
  },
  {
    icon: Cpu,
    title: 'Mixture of Experts (MoE)',
    description: 'Sparse activation for efficient large-scale models',
    color: 'accent'
  },
];

const LLMFoundationsSlide = () => {
  return (
    <SlideLayout>
      <SlideTitle 
        subtitle="Understanding the building blocks of modern language models"
      >
        LLM Foundations
      </SlideTitle>
      
      <SlideContent>
        <div className="grid md:grid-cols-3 gap-6">
          {topics.map((topic, index) => {
            const Icon = topic.icon;
            return (
              <div key={index} className="slide-card group hover:border-primary/40 transition-all duration-300">
                <div className={`w-12 h-12 rounded-xl bg-${topic.color}/10 border border-${topic.color}/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className={`w-6 h-6 text-${topic.color}`} />
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
                  {topic.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {topic.description}
                </p>
              </div>
            );
          })}
        </div>
        
        <div className="mt-8 p-4 rounded-xl bg-primary/5 border border-primary/20">
          <p className="text-sm text-muted-foreground">
            <strong className="text-primary">Key Takeaway:</strong> Modern LLMs balance scale with efficiency through sparse activation.
          </p>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default LLMFoundationsSlide;
